import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import { BooleanStatusChipField, FunctionField } from 'shared/react-admin/Fields';
import { User } from 'types/embedded/user';

export const UsersShowChipFields = () => {
  return (
    <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
      <FunctionField
        render={(record: User) => <Chip label={`ID: ${record?.originId}`} size="small" />}
      />
      <FunctionField
        render={({ firstName, lastName }: User) => (
          <Chip label={`Пользователь: ${firstName} ${lastName}`} size="small" />
        )}
      />
      <BooleanStatusChipField disabledLabel="Неактивен" enabledLabel="Активен" source="enabled" />
    </Stack>
  );
};
